import { searchButtonClick } from './main-page';
import { searchPageOpen, offerPriceClick } from './search-page';
import { selectFareFamily } from './fare-page';
import { revenuePageOpen, successBooking } from './products-page';
import { payButtonClick } from './payment-page';

export const bloomreachEventsLib = {
  searchButtonClick,
  searchPageOpen,
  offerPriceClick,
  selectFareFamily,
  revenuePageOpen,
  successBooking,
  payButtonClick,
};

export * as bloomreachEventsConfig from './config';
